class AlgoliaClearRefinements extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.createWidget = this.createWidget.bind(this);
    this.render = this.render.bind(this);
    this.renderContainer = this.renderContainer.bind(this);
    this.renderContent = this.renderContent.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      clearAll: this.getAttribute('clear-all')
    }
  }

  /**
   * Creates an instance of the clear refinements widget.
   * @param {Object} configuration - Configuration object for rendering.
   * @param {Object} instances - Instances object containing algolia instances.
   * @returns {Object} The created clear refinements widget instance.
   */
  createWidget(configuration, instances) {
    const { connectClearRefinements } = instances.instantSearch.connectors;
    const connectedClearRefinements = connectClearRefinements(this.render);

    const selector = `.${configuration.container}`;
    const container = document.querySelector(selector);

    const clearRefinementsWidget = connectedClearRefinements({ container });
    return clearRefinementsWidget;
  }

  /**
   * Renders the clear refinements widget with the provided render options.
   * @param {Object} renderOptions - Options for rendering the widget.
   * @param {boolean} isFirstRender - Indicates whether this is the first render.
   * @returns {void}
   */
  render(renderOptions, isFirstRender) {
    const { canRefine, refine, widgetParams } = renderOptions;
    const { container } = widgetParams;
    container.classList.toggle('hidden', !canRefine);

    if (!isFirstRender) return;

    const elements = this.renderContent();
    
    container.innerHTML = '';
    elements.forEach(element => container.appendChild(element));

    const anchor = container.querySelector('a');
    if (!anchor) return;

    anchor.addEventListener('click', (event) => {
      event.preventDefault();
      refine();
    });
  }

  /**
   * Renders the container for the clear refinements widget.
   * @param {Object} configuration - Configuration object for rendering.
   * @param {Function} html - The HTML template function.
   * @returns {string} The rendered container.
   */
  renderContainer(configuration, html) {
    const wrapperClassNames = `active-facets ${configuration.isMobile ? 'active-facets-mobile' : 'active-facets-desktop'}`;
    const containerClassNames = `${configuration.container} active-facets-vertical-filter`;
    return html`
      <div class="${wrapperClassNames}">
        <div class="ais-facets-vertical-container"></div>
        <div class="${containerClassNames}"></div>
      </div>
    `;
  }

  /**
   * Renders the content.
   * @returns {string} The rendered content HTML.
   */
  renderContent() {
    const label = this.settings.clearAll;
    const h2 = document.createElement('h2');
    h2.classList.add('facets__heading', 'facets__heading--vertical', 'caption-large', 'text-body');
    h2.id = 'verticalTitle';
    h2.tabIndex = -1;
    h2.textContent = ' ';
    
    const facetRemove = document.createElement('facet-remove');
    facetRemove.classList.add('active-facets__button-wrapper');

    const anchor = document.createElement('a');
    anchor.classList.add('active-facets__button-remove', 'underlined-link');
    anchor.role = 'button';
    anchor.href = '';

    const span = document.createElement('span');
    span.textContent = label;

    anchor.appendChild(span);
    facetRemove.appendChild(anchor);

    return [h2, facetRemove];
  }
}

customElements.define("algolia-clear-refinements", AlgoliaClearRefinements);